import { render, staticRenderFns } from "./ForWhoDropdown.vue?vue&type=template&id=2adc4565&"
import script from "./ForWhoDropdown.vue?vue&type=script&lang=ts&"
export * from "./ForWhoDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports